export interface Faq {
  q: string;
  a: string;
}

export const faqList: Faq[] = [
  {
    q: "什么是泡面番？",
    a: "泡面番是动漫圈对单集时长特别短（通常3到7分钟）的番剧的昵称，意思是「泡一碗泡面的功夫就能看完一集」。它们以轻松搞笑、节奏明快著称，很适合在碎片时间观看。",
  },
  {
    q: "泡面番和三分钟短番有什么区别？",
    a: "两者在很多情况下可以混用，但严格来说，「三分钟短番」强调的是单集约三分钟的极短时长，而「泡面番」更强调「泡面式」的轻松随性观看体验。小水看番里，三分钟短番是泡面番中的超短分支。",
  },
  {
    q: "哪些番剧适合一口气看完？",
    a: "所有单集短、节奏轻快的日常搞笑短番和下饭番都适合一口气看完。它们没有复杂的连续剧情，随时暂停随时继续，非常适合周末窝在沙发上连刷数集。",
  },
  {
    q: "在哪里可以看这些短番？",
    a: "主流的动漫视频平台都能看到泡面番，小水看番为你整理好了推荐清单和观看指南，你可以根据每部番剧页面提供的信息，前往对应的正版平台观看。",
  },
  {
    q: "下饭番真的适合吃饭时看吗？",
    a: "非常适合。下饭番节奏轻快、笑点密集、剧情轻松，不需要盯着字幕也能跟上，是公认的「干饭搭子」。不过笑点太密集的下饭番建议嘴里没食物时再看，以免笑喷。",
  },
];